import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
	{
		path: '/settings',
		name: 'Settings',
		component: () => import("@/views/Settings.vue")
	},
	{
		path: '/businesses',
		name: 'Businesses',
		component: () => import("@/views/Businesses.vue")
	},
	{
		path: '/invoices/:id',
		name: 'Invoice',
		component: () => import("@/views/Invoice.vue")
	},
	{
		path: '/invoices',
		name: 'Invoices',
		component: () => import("@/views/Invoices.vue")
	},
	{
		path: '/customers',
		name: 'Customers',
		component: () => import("@/views/Customers.vue")
	},
	{
		path: '*',
		redirect: { name: "Invoices" }
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
